import {REQUEST_CUSTOMERS, REQUEST_CUSTOMERS_FAILURE, REQUEST_CUSTOMERS_SUCCESS} from "../../../constant/master/TransCustomerConstant";

const initialState = {
    customers: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const customersReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_CUSTOMERS:
            return {
                ...state,
                customers: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_CUSTOMERS_SUCCESS:
            return {
                ...state,
                customers: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_CUSTOMERS_FAILURE:
            return {
                ...state,
                customers: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
